/**
 * Resize iframe to fit the container while on load.
 * Listen child session time out and redirect to login page
 */
angular.module('qkr').directive('iframeSetDimentionsOnload', ['appConfig', function(appConfig) {
    return {
        restrict: 'A',
        link(scope, element, attrs) {
            element.on('load', () => {
                console.log('Loaded resize iframe');

                // Create IE + others compatible event handler
                const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
                const eventer = window[eventMethod];
                const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

                // Listen to message from child window
                eventer(messageEvent, (e) => {
                    console.log('parent received message!:  ', e.data);

                    if (e.data === 'INVALID_SESSION') {
                        // When iframe child application session time out, it will post message to parent MSS
                        window.location = appConfig.logoutUrl + '?timeout=true';
                    } else {
                        // Required iframe child page to use postMessage to send its document height, so that iframe can resize to the correct size.
                        element.css('width', '100%');
                        element.css('height', e.data + 'px');
                    }
                }, false);
            });
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/directives/iframe_resize.js